export default __webpack_public_path__ + "images/129cf77ef06617bc43f75d2170e0f975-icon-location-image.svg";